import { Box, Text } from "@chakra-ui/react";

/**
 * Wraps a £ spend value in a purple-bordered box to flag it as ESG_ADMIN-only data —
 * shown nowhere else in the app to non-admins. Used inside chart tooltips and the page
 * header's total allowance figure (see AIStatus.jsx, AllowanceProgressChart.jsx,
 * MonthlyUsageChart.jsx).
 */
export default function AdminOnlyValue({ children, fontSize = "body.s" }) {
  return (
    <Box border="1px solid" borderColor="purple.500" bg="purple.50" borderRadius="md" px={2} py={1}>
      <Text fontSize={fontSize} color="purple.700" fontWeight="600">
        {children}
      </Text>
    </Box>
  );
}
